import { Component, OnInit, Query } from '@angular/core';
import { ApiService } from '../services/api.service';
import { LocalStorageService } from '../services/localstorage.service';
import { SharedService } from '../services/shared.service';
import { IAuth, IAuthErrors, IAuthToken } from '../interfaces';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.scss']
})
export class ConnectComponent implements OnInit {
  public auth: IAuth = {};
  public errors: IAuthErrors = {};

  constructor(
    private _route: ActivatedRoute,
    private _api: ApiService,
    private _storage: LocalStorageService,
    private _router: Router,
    private _sharedService: SharedService
  ) { }

  ngOnInit() {
    this._route
      .params
      .subscribe(
        (params: Params) => {
          this._storage.set('community_id', this._route.snapshot.queryParamMap.get('community_id'));
          this._storage.set('token', params.token);
          this.getUser();
        });

  }

  getUser(): void {
    this._api.me
      .retrieve('me')
      .subscribe(
        (data) => {
          if (!this._storage.get('community_id')) {
            this._storage.set('community_id', data.communities[0].id);
          }
          this._storage.setObject('user', data);
          this.getPermissions();
        },
        (errors) => {
          console.log(errors);
        })
  }

  private getPermissions() {
    this._api.permissions
      .retrieve(this._storage.get('community_id') + '/permissions')
      .subscribe(
        (data) => {
          const user = this._storage.getObject('user');
          this._storage.setObject('user', Object.assign(user, data));
          this._sharedService.emitChange({ user: true });

          this._route
            .queryParams
            .subscribe((params: Params) => {
              let {next, ...qparams} = this._route.snapshot.queryParams;
              next = next || '/'
              setTimeout(() => this._router.navigate([next], { queryParams: qparams }), 200)
            })
        },
        (err) => { console.log(err) });
  }

}



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/connect/connect.component.ts